<template>
    <router-view></router-view>
</template>
<script>
export default {
  name: 'SubHome',
};
</script>
<style scoped>
</style>
